import { render, staticRenderFns } from "./SupplementalMessagesList.vue?vue&type=template&id=89c44538&"
import script from "./SupplementalMessagesList.vue?vue&type=script&lang=js&"
export * from "./SupplementalMessagesList.vue?vue&type=script&lang=js&"
import style0 from "./SupplementalMessagesList.vue?vue&type=style&index=0&id=89c44538&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports